/* eslint-disable camelcase */
import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import isNil from "lodash/fp/isNil";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";

class RoutesPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Route",
      state: "route",
      name: "route",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "City", name: "city" },
      { title: "Corporate", name: "corporate" },
      { title: "Price", name: "price", isSortable: true },
    ];

    this.filters = [
      {
        name: "route_type",
        title: "Dynamic",
        icon: "directions_car",
        list: "routeType",
      },
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Route",
        state: "route",
        size: 25,
      },
      {
        name: "private_bus_request",
        title: "Private Bus Request",
        icon: "airport_shuttle",
        list: "isPrivateBusReq",
      },
    ];

    this.addOptions = {
      title: "Add New Route",
      icon: "add",
      fields: [
        {
          resource: "City",
          name: "city",
          title: "City",
          isRequired: true,
          isResource: true,
        },
        {
          name: "name_i18n",
          title: "Name",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "description",
          title: "Description",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          name: "from_display_name_i18n",
          title: "From",
          type: "text",
          isI18nText: true,
        },
        {
          name: "to_display_name_i18n",
          title: "To",
          type: "text",
          isI18nText: true,
        },
        {
          name: "price",
          title: "Price",
          type: "number",
          isText: true,
          isRequired: true,
          formatter: (item) => item * constants.currencyBy,
        },
        {
          name: "dispatch",
          title: "Dispatch",
          isCheckBox: true,
          isRequired: true,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const formatPrice = (item) => {
      item.price = !isNil(item.city)
        ? `${item.price / constants.currencyBy} ${item.city.currency}`
        : item.price / constants.currencyBy;
      return item;
    };

    return map(flow([getSource, formatPrice]))(data);
  }
}

export default RoutesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/routes/routes.transforms.js